import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["grid", "sentinel"]
  static values = { url: String, page: Number, loading: Boolean, exhausted: Boolean }

  connect() {
    this.pageValue = this.pageValue || 1
    this.loadingValue = false
    this.exhaustedValue = false

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.loadingValue && !this.exhaustedValue) {
            this.loadMore()
          }
        })
      },
      { rootMargin: "200px" }
    )

    if (this.hasSentinelTarget) {
      this.observer.observe(this.sentinelTarget)
    }
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  hideSentinel() {
    if (this.hasSentinelTarget) {
      this.sentinelTarget.style.display = "none"
    }
  }

  async loadMore() {
    this.loadingValue = true
    this.pageValue += 1

    const urlObj = new URL(this.urlValue, window.location.origin)
    urlObj.searchParams.set("page", this.pageValue)
    const url = urlObj.pathname + urlObj.search

    try {
      const response = await fetch(url, {
        headers: { "Accept": "text/html" }
      })

      if (!response.ok) {
        this.exhaustedValue = true
        return
      }

      const html = await response.text()
      const parser = new DOMParser()
      const doc = parser.parseFromString(html, "text/html")
      const newCards = doc.querySelectorAll(".library-task-card")

      if (newCards.length === 0) {
        this.exhaustedValue = true
        this.hideSentinel()
        return
      }

      newCards.forEach((card) => {
        this.gridTarget.appendChild(card)
      })

      // If fewer cards than a full page, we've reached the end
      if (newCards.length < 24) {
        this.exhaustedValue = true
        this.hideSentinel()
      }
    } catch (e) {
      this.exhaustedValue = true
      this.hideSentinel()
    } finally {
      this.loadingValue = false
    }
  }
}
